import { Box } from '@mui/material';

export function Section(props) {
  return (
    <Box
      sx={{
        mt: { xs: 2, sm: 3 },
        pt: { xs: 2, sm: 3 },
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {props.children}
    </Box>
  );
}
